import { jsx as _jsx } from "react/jsx-runtime";
import { useDialog } from '../context/DialogContext';
import GalleryModalBase from '../../../components/common/GalleryModal';
export const GalleryModal = (props) => {
    const { confirm } = useDialog();
    // Custom delete handler that uses DialogContext
    const handleDelete = async (upload) => {
        return await confirm({
            title: 'Delete upload?',
            description: `Are you sure you want to delete ${upload.filename}?`,
            confirmText: 'Delete',
            variant: 'destructive',
        });
    };
    // Custom tag removal confirmation that uses DialogContext
    const handleConfirmRemoveTag = async (tag) => {
        return await confirm({
            title: 'Remove tag?',
            description: `Are you sure you want to remove the tag "${tag}"?`,
            confirmText: 'Remove',
            variant: 'destructive',
        });
    };
    return (_jsx(GalleryModalBase, { ...props, onDelete: handleDelete, onConfirmRemoveTag: handleConfirmRemoveTag }));
};
export default GalleryModal;
